import React from "react";
import { Link } from "react-router-dom";
import {
  InfoMedia,
  Widget,
  AboutWidget,
  CategoryWidget,
  RecentPostWidget,
  IconLink,
} from "../../components/";

// Widget Datas
import widgetsdata from "../../data/widgets.json";

const { pageList, exploreLinks, recentPosts } = widgetsdata;

const FooterThree = () => (
  <footer className="footer-wrapper footer-layout3">
    <div className="footer-top">
      <div className="container">
        <div className="row">
          <div className="footer-media style2 col-sm ">
            <InfoMedia
              icon="fal fa-map-marker-alt"
              title="Office Address"
              info="259 Hilton Street, MK 256 North, United State"
            />
          </div>
          <div className="footer-media style2 col-sm">
            <InfoMedia
              icon="fal fa-clock"
              title="Working Hours"
              info="Weekdays 8am - 22pm Weekend 10am - 12pm"
            />
          </div>
          <div className="footer-media style2 col-sm">
            <InfoMedia
              icon="fal fa-phone-volume"
              title="Contact Us"
              info={
                <>
                  <a href="mailto:info@example.com">
                    atendimento@smarttaxreturns.com
                  </a>
                  <br />
                  <a href="tel:+2597462153">+1(227)245-1111</a>
                </>
              }
            />
          </div>
        </div>
      </div>
    </div>
    <div className="widget-area">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-6 col-xl-auto">
            <Widget widgetTitle="About Us" className="footer-widget">
              <AboutWidget>
                <AboutWidget.Text>
                  Na Smart Tax Returns, nossa missão é fornecer soluções fiscais
                  e empresariais de alta qualidade para indivíduos e empresas
                  que buscam sucesso nos Estados Unidos. Nossa equipe de
                  especialistas está comprometida em oferecer um atendimento
                  personalizado e eficiente, garantindo que você alcance seus
                  objetivos financeiros com tranquilidade.
                </AboutWidget.Text>
                <IconLink className="footer-social">
                  <IconLink.Item
                    icon="fab fa-facebook-f"
                    path="https://www.facebook.com/profile.php?id=61571793860239"
                  />
                  <IconLink.Item
                    icon="fab fa-instagram"
                    path="https://www.instagram.com/smarttax.returns/"
                  />
                </IconLink>
              </AboutWidget>
            </Widget>
          </div>
          <div className="col-6 col-xl-auto">
            <Widget
              widgetTitle="Links"
              className="widget_nav_menu footer-widget"
            >
              <CategoryWidget>
                {pageList.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
              </CategoryWidget>
            </Widget>
          </div>
          <div className="col-6 col-xl-auto">
            <Widget
              widgetTitle="Explore"
              className="widget_nav_menu footer-widget"
            >
              <CategoryWidget>
                {exploreLinks.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
              </CategoryWidget>
            </Widget>
          </div>
          <div className="col-md-6 col-xl-auto">
            <Widget widgetTitle="Lastest Post" className="footer-widget">
              {recentPosts.slice(0, 2).map((post) => (
                <RecentPostWidget
                  key={post.id}
                  title={post.title}
                  image={post.image}
                  date={post.date}
                />
              ))}
            </Widget>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright-wrap">
      <div className="container">
        <p className="copyright-text">
          Copyright <i className="fal fa-copyright" /> 2022{" "}
          <Link className="text-white" to="/">
            TechBiz
          </Link>
          . All rights reserved by{" "}
          <a
            className="text-white"
            href="https://themeforest.net/user/vecuro_themes"
          >
            Vecuro
          </a>
          .
        </p>
      </div>
    </div>
  </footer>
);

export default FooterThree;
